<template>
	<button class="btn btn--color" @click="ShowAddEditStorePopup = !ShowAddEditStorePopup">Добавить группу</button>

	<transition name="modal">
		<AddEditStorePopup v-if="ShowAddEditStorePopup" @refreshList="this.requestStoreGroups(filter)" @close="ShowAddEditStorePopup = false" />
	</transition>

</template>
<script>
import AddEditStorePopup from "@/components/sections/Store/AddEditStorePopup.vue";
import {mapActions} from "vuex";

export default {
	name: "AddStoreAdd",
	components: {AddEditStorePopup},
	data() {
		return {
			ShowAddEditStorePopup: false,
			filter: {
				name: '',
				offset: 0,
				limit: 10
			}
		}
	},
	methods: {
		...mapActions({
			requestStoreGroups: 'storeGroups/requestStoreGroups',
		}),
	},
}
</script>


